import { Component, Input, OnInit, ViewChild, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { UserInfo } from '@app-store/session/session.store';
import { SessionService } from '@app-store/session/session.service';
import { SessionStore } from '@app-store/session/session.store';
import { SidebarService } from '@app-services/sidebar.service';
import { UserProfile } from '@app-model/user';
import { of } from 'rxjs';
import { UserService } from '@app-services/user.service';
import { FilterService } from '@app-services/filter.service';


@Component({
    selector: 'app-layout-restrict-area-header',
    templateUrl: './layout-restrict-area-header.component.html',
    standalone: false
})
export class LayoutRestrictAreaHeaderComponent implements OnInit {
	sessionStore = inject(SessionStore);
  @ViewChild('filterDrop')
  filterDrop;

	@Input() userProfile: UserProfile;
	showSidebar = false;
	showArea: boolean[] = [];

	isAuthenticated = this.sessionStore.isAuthenticated;
  		userInfo = this.sessionStore.userInfo;

	notifications: any[];

	constructor(
    private userService: UserService,
		private sidebarService: SidebarService,
		private sessionService: SessionService,
    private filterService: FilterService
  ) {
		//this.userService.getUserProfile().subscribe((userProfile: any) => {
		//	this.userProfile = userProfile;
	  //	});

    filterService.getFilterEmitter()
      .subscribe(() => this.filterDrop.open());
	}

	closeSidebar(): void {
		this.showSidebar = false;
		this.showArea.forEach(area => (area = false));
	}

	toggle(area: string): void {
		this.showArea[area] = !this.showArea[area];
	}

	hasRole(role: string): Observable<boolean> {
		return of(true);
	}

	hasAnyRole(roles: string[]): Observable<boolean> {
		return of(true);
	}

	ngOnInit() {
	}

	toggelSidebar() {
		this.sidebarService.active = !this.sidebarService.active;
	}

	signout() {
		this.sessionService.logout();
	}
}
